import { Title, Media, Texts } from "../Object";
import { Space } from "../Layout";
import { Scroll } from "../Animation";

const Message = () => {
  return (
    <>
      <div className="p-box__wrap--top-dec">
        <div className="l-row" data-state="right-med">
          <div className="c-grid__wrap--content-media">
            <Scroll>
              <div className="c-grid__content">
                <Title slug="message" />
                <Space size={["40px 0 0", "32px 0 0"]}>
                  <Texts slug="message/body" class="c-text--med" />
                </Space>
              </div>
            </Scroll>
            <Media
              sp="sp"
              src="message/message-media"
              alt="media"
              class="p-img__over-top"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Message;
